
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
   Programmer / Service Support
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Qualification : </h3>
                <p> <span class="step_no">1</span> B.E / B.Tech / M.Tech in Computer Science (CS) /Information Technology (IT) / Electronics and Communication engineering (ECE) or equivalent.
				</p>
               <H5>OR</H5>
               <p> <span class="step_no">2</span> MCA / DOEACC ('B' or 'c' Level) with specialization in computers or equivalent.
                </p>
                <H5>OR</H5>
               <p> <span class="step_no">3</span> M.Sc. / M.Phil / Ph.D in Mathematics / Physics / Statistics / Operation Research / Computer Science / Information technology / Electronics with specialization in computer or equivalent.
              </div>
            </div>
          </div>
          <!-- feature box close -->
  
       
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Job profile:</h3>
        <p> <span class="step_no">1</span>Writing code for computer programs and mobile applications; involved in maintaining, debugging, and troubleshooting systems and software to ensure that everything is running smoothly; under the supervision of full stack developer.</p>
        <p> <span class="step_no">2</span> To manage,support and service for the DGT, NSTIs,RDSDEs and other websites / portals</p>     
        <!--<p> <span class="step_no">1</span>At least 2+ years of experience in Database Management.</p>
		<p> <span class="step_no">2</span>Advanced proficiency in Structured Query Language (SQL).</p>
        <p> <span class="step_no">3</span>In-depth knowledge of Database Technologies, Architecture and Data security.</p>
		<p> <span class="step_no">4</span>Experience in Designing Logical / Physical Data Models and create Physical Databases for the Software Development Projects</p>
		<p> <span class="step_no">5</span>Experience in developing Functions and Triggers</p>
		<p> <span class="step_no">6</span>Experience in Management Information Systems (MIS)</p>-->
		
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Experience :</h3>
        <p> <span class="step_no">1</span> 1 to less than 3 years with relevant experience with certification.*</p>
        <h5>OR</h5>
        <p> <span class="step_no">2</span> 3 years and above with relevant experience</p>

		<!--<p> <span class="step_no">2</span> Strong in knowledge in implementing Functions and Triggers</p>
        <p> <span class="step_no">3</span> Database : My Sql / SQL Server / Oracle / Mongo DB / Postgres SQL</p>
		<p> <span class="step_no">4</span> Experience in PHP My Admin</p>
        <p> <span class="step_no">5</span> Experience in working with agile methodologies. </p>-->
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. (50,000 - 60,000)- per month (consolidated pay)  </p>
		<!--<p> <span class="step_no">2</span> Rs. 1,00,000/- per month (consolidated pay) for 3+ Experience from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.  </p>-->


      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <!--<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Responsibilities:</h3>
        <p> <span class="step_no">1</span>Design logical/physical data models and create physical databases for the software development projects</p>
        <p> <span class="step_no">2</span> Maintain database throughout the life cycle of a project  </p>
        <p> <span class="step_no">3</span> Develop database structures and features according to organizational needs.</p>
        <p> <span class="step_no">4</span> Help developers to achieve the desired performance with the database operations optimizing the database objects and queries.</p>
        <p> <span class="step_no">5</span> Guide Programmers and others on performance requirements. </p>
		<p> <span class="step_no">6</span>Review modifications to existing software to improve efficiency and performance.</p>
        <p> <span class="step_no">7</span>Examine new application design and recommend corrections if required.</p>
<p> <span class="step_no">8</span>Could be assigned as the person responsible for a project or phase of a project. </p>
 
        <p> <span class="step_no">9</span>Experience of independently connecting with stakeholders for development of reports / resolving queries</p>
        <p> <span class="step_no">10</span> Develop Functions and Triggers in the Database</p>
		
		
		
		<p> <span class="step_no">11</span>Ability in Enhancing the scalability and performance of existing database architecture.</p>
<p> <span class="step_no">12</span>Performing database maintenance, migration, and upgrading hardware and software.</p>
<p> <span class="step_no">13</span>Protecting data by developing data security and restoration policies, procedures, and controls.</p>
<p> <span class="step_no">14</span>Knowledge of best practices in database management.</p>
<p> <span class="step_no">15</span>Advanced analytical, leadership, and problem-solving skills.</p>



      </div>
    </div>
  </div>-->
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 09th July 2022 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <!--<p><span class="step_no">1</span>Chennai</p>-->
		<p><span class="step_no">1</span>Delhi</p>
	
		
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee.</p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
<p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  
     <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
		<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority. </p>


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  
<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>







